import { Typography } from '@mui/material';
import { FC } from 'react';

import { headerColumns } from 'containers/POSPage/PosTable/constant';
import {
  HeaderBox,
  OrderTableContent,
  OrderTableHeader,
  OrderTableWrapper,
} from 'containers/POSPage/PosTable/index.styled';
import PosTableCard from 'containers/POSPage/PosTableCard';

import { POSQueue } from 'types/pos.interface';

interface PosTableProps {
  rows: POSQueue[];
  handleOrderClick: (orderId: string) => void;
  handleDelete: (queue: POSQueue) => void;
}

const PosTable:FC<PosTableProps> = ({ rows, handleOrderClick, handleDelete }) => {
  const onCustomerHover = () => {
    console.log('TODO: add handler when on hover customer details'); // eslint-disable-line
  };

  /** @TODO add delete handler to the menu */
  console.log(handleDelete); // eslint-disable-line

  return (
    <OrderTableWrapper>
      <OrderTableHeader>
        {headerColumns.map(({ label, flex, noBorder }, index) => (
          <HeaderBox key={label} flex={flex} noBorder={noBorder}>
            <Typography variant="body3" fontWeight="bold" ml={index === 0 ? '16px' : 0}>
              {label}
            </Typography>
          </HeaderBox>
        ))}
      </OrderTableHeader>

      <OrderTableContent>
        {rows?.map((row) => (
          <PosTableCard
            key={row.timeIn}
            row={row}
            onCustomerHover={onCustomerHover}
            handleOrderClick={handleOrderClick}
          />
        ))}

        {!rows?.length && (
          <Typography>No queues available</Typography>
        )}

      </OrderTableContent>
    </OrderTableWrapper>
  );
};

export default PosTable;
